module.exports = __webpack_public_path__ + "media/images/sales/smakon/thumb-pricing-02-359b08d43dd4f843c6002faf3a4eb611.svg";